<template>
  <div class="pdf-create-header">
    <div class="template-info">
      <!-- <div class="template-name">
        <v-text-field
          label="Template Name"
          dense
          outlined
          hide-details
        ></v-text-field>
      </div> -->
      <div class="template-heading">Add/Edit Template</div>
      <div class="uploadimg-card">
        <v-file-input
          @change="onHeaderSelected"
          v-model="selectedHeader"
          color="deep-purple-accent-4"
          multiple
          dense
          placeholder="Upload Header Image"
          prepend-icon="mdi-paperclip"
          outlined
        >
        </v-file-input>
        <div class="myt-input-note">
          The header size is 2480px (width) x 45px (height). If the image is
          larger than this size, it will be scaled down accordingly
        </div>
        <div class="image-align-option">
          <div>Align:</div>
          <v-radio-group v-model="selectedOptionHeader" inline :disabled="backgroundHeaderImage && backgroundHeaderImage.length<1">
            <v-radio
              v-for="item in alignItems"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></v-radio>
            <!--v-radio label="Bottom" value="bottom"></v-radio>
            <v-radio label="Top" value="top"></v-radio-->
            <!-- <v-radio label="Cover" value="cover"></v-radio>
            <v-radio label="Contain" value="contain"></v-radio> -->
          </v-radio-group>
          <v-slider v-model="headerSlider" min="0" max="50" step="1" :disabled="selectedOptionHeader === 'center' || selectedPositionHeader === 'cover' || backgroundHeaderImage && backgroundHeaderImage.length<1"></v-slider>
          <div>Position:</div>
          <v-radio-group v-model="selectedPositionHeader" inline :disabled="backgroundHeaderImage && backgroundHeaderImage.length<1">
            <v-radio
              v-for="item in alignPostion"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></v-radio>
          </v-radio-group>
        </div>
      </div>
      <div class="uploadimg-card">
        <v-file-input
          @change="onFooterSelected"
          v-model="selectedFooter"
          color="deep-purple-accent-4"
          multiple
          dense
          placeholder="Upload Footer Image"
          prepend-icon="mdi-paperclip"
          outlined
        >
        </v-file-input>
        <div class="myt-input-note">
          The footer size is 2480px (width) x 45px (height). If the image is
          larger than this size, it will be scaled down accordingly
        </div>
        <div class="image-align-option">
          <div>Align:</div>
          <v-radio-group v-model="selectedOptionFooter" inline :disabled="backgroundFooterImage && backgroundFooterImage.length<1">
            <v-radio
              v-for="item in alignItems"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></v-radio>
            <!--v-radio label="Bottom" value="bottom"></v-radio>
            <v-radio label="Top" value="top"></v-radio-->
            <!-- <v-radio label="Cover" value="cover"></v-radio>
            <v-radio label="Contain" value="contain"></v-radio> -->
          </v-radio-group>
          <v-slider v-model="footerSlider" min="0" max="50" step="1" :disabled="selectedOptionFooter=='center' || selectedPositionFooter == 'cover' || backgroundFooterImage && backgroundFooterImage.length<1"></v-slider>
          <div>Position:</div>
          <v-radio-group v-model="selectedPositionFooter" inline :disabled="backgroundFooterImage && backgroundFooterImage.length<1">
            <v-radio
              v-for="item in alignPostion"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></v-radio>
          </v-radio-group>
        </div>
      </div>
      <div>
        <v-btn
          class="right-btn cust-btn mr-10-btn"
          color="primary"
          @click="onSave()"
          >Save</v-btn
        >

        <v-menu offset-y z-index="10" class="btn-index">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="right-btn cust-btn"
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="headerImageUrl!=null || footerImageUrl!=null"
                            >
                                Delete
                                <span class="drop-dwn-arrow-cp3">
                                    <img
                                        src="../../../assets/triangular-arrow-pointing-down.png"
                                        class="shop-more"
                                    />
                                </span>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="onDelete('HEADER')">
                                <v-list-item-title
                                    >Header</v-list-item-title
                                >
                            </v-list-item>
                            <v-list-item @click="onDelete('FOOTER')">
                                <v-list-item-title
                                    >Footer</v-list-item-title
                                >
                            </v-list-item>
                            <v-list-item @click="onDelete('BOTH')">
                                <v-list-item-title
                                    >Both</v-list-item-title
                                >
                            </v-list-item>
                        </v-list>
                    </v-menu>
      </div>
    </div>
    <div id="printMe" class="temp-preview">
      <div class="prev-temp">
        <div class="pdf-header" :class="[selectedOptionHeader,{'header-bg-blank' : !backgroundHeaderImage}]">
          <img
            v-if="backgroundHeaderImage"
            class="header-img"
            :style="imgStyleHeader"
            :class="selectedPositionHeader"
            :src="backgroundHeaderImage"
          />
        </div>
        <div class="header-border"></div>
        <div class="mid-content"></div>
        <div class="footer-border"></div>
        <div class="pdf-footer" :class="[selectedOptionFooter,{'footer-bg-blank' : !backgroundFooterImage}]">
          <img
            v-if="backgroundFooterImage"
            class="footer-img"
            :style="imgStyleFooter"
            :class="selectedPositionFooter"
            :src="backgroundFooterImage"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.header-border {
  border-top: 3px solid #000;
  border-bottom: 1px solid #000;
  width: 100%;
  margin-top: 5px;
  height: 6px;
}
.footer-border {
  border-bottom: 3px solid #000;
  border-top: 1px solid #000;
  width: 100%;
  margin-bottom: 5px;
  height: 6px;
}
.trangle-line {
  width: 10%;
  position: relative;
}
.trangle-line:before {
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  border-bottom: solid 30px transparent;
  border-top: solid 30px #333;
  border-left: solid 30px transparent;
  border-right: solid 30px transparent;
  top: -30px;
  left: 1vh;
  transform: rotate(-90deg);
}
.mid-cut-line {
  display: flex;
  height: 10vh;
  width: 100%;
  align-items: center;
}
.mid-content {
  height: calc(600px - 150px);
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  flex-direction: column;
  justify-content: center;
  border: 2px solid #333;
  margin-top: 10px;
  margin-bottom: 10px;
}
.top-cutting {
  height: 150px;
  border: 2px solid #333;
  border-radius: 0vh 0vh 30px 30px;
  width: 100%;
}
.dash-line {
  border: 2px dashed #333;
  height: 2px;
  width: 275px;
  margin-left: 22px;
}
.bottom-cutting {
  height: 150px;
  border: 2px solid #333;
  border-radius: 30px 30px 0 0;
  width: 100%;
}
.pdf-header.center {
  text-align: center;
}
.pdf-header.top {
  background-position: top;
}
.pdf-header.left {
  text-align: left;
}
.pdf-header.right {
  text-align: right;
}
.pdf-header.bottom {
  background-position: bottom;
}
.pdf-header.cover {
  background-size: cover;
}
.pdf-header.contain {
  background-size: contain;
}
.pdf-footer.center {
  text-align: center;
}
.pdf-footer.top {
  background-position: top;
}
.pdf-footer.left {
  text-align: left;
}
.pdf-footer.right {
  text-align: right;
}
.pdf-footer.bottom {
  background-position: bottom;
}
.pdf-footer.cover {
  background-size: cover;
}
.pdf-footer.contain {
  background-size: contain;
}
.temp-preview {
  width: 53%;
  margin-left: 2%;
  margin-top: 30px;
  position: relative;
  overflow: auto;
}
.pdf-header {
  height: 50px;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-height: 50px;
}
.pdf-footer {
  height: 35px;
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
}
.footer-bg-blank,
.header-bg-blank {
  background-color: #ddd;
}
.prev-temp {
  margin: 0 auto;
  border: 1px solid #000;
  width: 413px;
  height: 600px;
  padding: 10px 20px;
  margin-top: 24px;
}

.header-img {
  max-height: 49px !important;
  max-width: 100%;
}
.footer-img {
  max-height: 34px !important;
  max-width: 100%;
}
.contain {
  object-fit: contain;
}
.cover {
  object-fit: cover;
  width: 100%;
}
</style>
<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      headerImageUrl: null,
      headerFile: null,
      footerImageUrl: null,
      footerFile: null,
      selectedOptionHeader: "left",
      selectedOptionFooter: "left",
      headerPreview: null,
      footerPreview: null,
      creatorId: "",
      selectedPositionHeader: "contain",
      selectedPositionFooter: "contain",
      selectedHeader: null,
      selectedFooter: null,
      headerSlider: 0,
      footerSlider: 0,
      alignItems: [
        {
          label: "Left",
          value: "left"
        },
        {
          label: "Center",
          value: "center"
        },
        {
          label: "Right",
          value: "right"
        }
      ],
      alignPostion: [
        {
          label: "Contain",
          value: "contain"
        },
        {
          label: "Cover",
          value: "cover"
        }
      ]
    };
  },
  mounted() {
    this.creatorId = localStorage.getItem("guest_user_id");
    this.requestTemplate();
  },
  methods: {
    ...mapActions({
      saveTemplate: "testStore/saveTemplate",
      getTemplate: "testStore/getTemplate",
      removeTemplate: "testStore/removeTemplate"
    }),

    onHeaderSelected(event) {
      this.headerFile = event[0];
      if (this.headerFile) {
        this.headerImageUrl = URL.createObjectURL(this.headerFile);
      } else {
        this.headerImageUrl = null;
      }
    },
    requestTemplate() {
      let reqData = {
        user_id: this.user ? this.user.id.toString() : this.creatorId
      };
      this.getTemplate(reqData)
        .then((response) => {
          if (response && (response.header_url || response.footer_url)) {
            if(response && response.header_url){
              this.headerPreview = response.header_url;
              let alignmentHeader = JSON.parse(response.header_details);
              this.selectedOptionHeader = alignmentHeader.align;
              this.selectedPositionHeader = alignmentHeader.position;
              this.headerSlider = parseInt(
               alignmentHeader.margin.replace("%", "")
              );
            } else {
              this.headerPreview = null;
             }
            if(response && response.footer_url){
              this.footerPreview = response.footer_url;
              let alignmentFooter = JSON.parse(response.footer_details);
              this.selectedOptionFooter = alignmentFooter.align;
              this.selectedPositionFooter = alignmentFooter.position;
              this.footerSlider = parseInt(
               alignmentFooter.margin.replace("%", "")
              );
            } else {
              this.footerPreview = null;
             }
          } else {
            this.headerPreview = this.footerPreview = null;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onFooterSelected(event) {
      this.footerFile = event[0];
      if (this.footerFile) {
        this.footerImageUrl = URL.createObjectURL(this.footerFile);
      } else {
        this.footerImageUrl = null;
      }
    },
    onSave() {
      if (
        (this.footerImageUrl || this.headerImageUrl) ||
        (this.headerPreview ||
          this.footerPreview)
      ) {
        let formdata = new FormData();
        let headerSlider =
          this.selectedOptionHeader == "center" ||
          this.selectedPositionHeader == "cover"
            ? `${0}%`
            : `${this.headerSlider}%`;
        let footerSlider =
          this.selectedOptionFooter == "center" ||
          this.selectedPositionFooter == "cover"
            ? `${0}%`
            : `${this.footerSlider}%`;
        formdata.append("header", this.headerFile);
        formdata.append(
          "reqData[user_id]",
          this.user ? this.user.id.toString() : this.creatorId
        );
        formdata.append("footer", this.footerFile);

        formdata.append(
          "reqData[header_details]",
          JSON.stringify({
            align: this.selectedOptionHeader,
            position: this.selectedPositionHeader,
            margin: headerSlider
          })
        );
        formdata.append(
          "reqData[footer_details]",
          JSON.stringify({
            align: this.selectedOptionFooter,
            position: this.selectedPositionFooter,
            margin: footerSlider
          })
        );

        this.saveTemplate(formdata)
          .then((response) => {
            this.$toasted.success(response.message);
            this.selectedHeader = null;
            this.selectedFooter = null;
            this.headerFile = null;
            this.footerFile = null;
            this.headerImageUrl = null;
            this.footerImageUrl = null;
            this.requestTemplate();
          })
          .catch((err) => {});
      } else {
        this.$toasted.error("Please upload header/footer");
      }
    },
    onDelete(template){
      if((template=='BOTH' && (this.headerPreview || this.footerPreview)) ||
         (template=='HEADER' && this.headerPreview) ||
         (template=='FOOTER' && this.footerPreview) ){
        let reqData = {
        user_id: this.user ? this.user.id.toString() : this.creatorId,
        header: template=='HEADER' || template=='BOTH',
        footer: template=='FOOTER' || template=='BOTH'
        
        };
        this.removeTemplate(reqData)
          .then((response) => {
            this.requestTemplate();
            this.$toasted.success(response.message);
          })
          .catch((err) => {
            
          });
      }
      else{
        template=='BOTH' ? this.$toasted.error("Header/Footer template not found. Please make sure it has been uploaded") : 
        template=='HEADER' ? this.$toasted.error("Header template not found. Please make sure it has been uploaded") :
        this.$toasted.error("Footer template not found. Please make sure it has been uploaded") 
      }
    }
  },
  computed: {
    ...mapState("userStore", ["user"]),
    backgroundHeaderImage() {
      if (this.headerFile) {
        return this.headerImageUrl;
      }
      if (this.headerPreview) {
        return this.headerPreview;
      }
      return "";
    },
    backgroundFooterImage() {
      if (this.footerFile) {
        return this.footerImageUrl;
      }
      if (this.footerPreview) {
        return this.footerPreview;
      }
      return "";
    },
    imgStyleHeader() {
      let headerSlider = `${this.headerSlider}%`;
      if (
        this.selectedOptionHeader == "left" &&
        this.selectedPositionHeader == "contain"
      ) {
        return { marginLeft: headerSlider };
      }
      if (
        this.selectedOptionHeader == "right" &&
        this.selectedPositionHeader == "contain"
      ) {
        return { marginRight: headerSlider };
      }
    },
    imgStyleFooter() {
      let footerSlider = `${this.footerSlider}%`;
      if (
        this.selectedOptionFooter == "left" &&
        this.selectedPositionFooter == "contain"
      ) {
        return { marginLeft: footerSlider };
      }
      if (
        this.selectedOptionFooter == "right" &&
        this.selectedPositionFooter == "contain"
      ) {
        return { marginRight: footerSlider };
      }
    }
  },
  watch: {
    user(val) {
      if (val && val.id) {
        this.requestTemplate();
      }
    }
  }
};
</script>
